import { render } from "./AddSpecimens.vue?vue&type=template&id=42a8340b&scoped=true"
import script from "./AddSpecimens.vue?vue&type=script&lang=js"
export * from "./AddSpecimens.vue?vue&type=script&lang=js"

import "./AddSpecimens.vue?vue&type=style&index=0&id=42a8340b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a8340b"]])

export default __exports__